import { Injectable } from "@angular/core";
import { DataService } from "../data.service";
import { environment } from "../../../environments/environment";
import { HttpClient ,HttpHeaders} from "@angular/common/http";
import { CommonFunctionService ,UserMerchantData} from '../Common/common-function.service';
import { VposInvoiceAppView } from 'src/app/models/vpos-invoice-app-view';
import { VposInvoiceDataSettingsAppView } from '../../models/vpos-invoice-data-settings-app-view';
import { VposInvoiceTemplateMasterAppView } from '../../models/vpos-invoice-template-master-app-view';
import { catchError, map } from "rxjs";
@Injectable()
export class InvoiceService {
  userId: any;
  token;
  headers: any;

  constructor(private service: DataService, private http: HttpClient, private common:CommonFunctionService) {
    let loggedUsername =this.common.getUserName()
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token =environment.GetAuthenticationToken + ":" +this.common.GetAuthToken()+ ":" + "IT"+ ":"+environment.GetAuthencticationKey+":"+this.common.getSid()+":"+merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
    set('Authorization', 'basic ' + btoa(this.token));
  }

  newInvoice(data) {
    this.GetHeaderdetails();
    return this.http.post(environment.newInvoiceUrl, data, { headers:this.headers });


    
    // return this.service.create(environment.newInvoiceUrl, data);
  }
  invoiceDataSettings(data1,data) {
    this.GetHeaderdetails();
    return this.service.create(environment.invoiceDataSettingsUrl+"?FieldNames="+data1, data);
  }
  updateInvoice(data) {
    this.GetHeaderdetails();
    return this.http.put(
      environment.updateInvoiceUrl + "?id=" + data.Id,
      data,{headers:this.headers}
    );
  }
  getInvoiceTemplateByMerchantKeyId(data) {
    this.GetHeaderdetails();
    // alert(merchantKeyId);
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http
      .get<VposInvoiceDataSettingsAppView>(environment.TemplateByMerchantKeyIdUrl + "?MerchantKeyId=" + data+ "&LoginUserId="+merchantdata.UserId
      )
      .pipe(map(response => response) ,catchError(this.common.handleError));
  }
  getTemplateList()
  {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http
    .get<VposInvoiceTemplateMasterAppView>(
      environment.getInvoiceTemplatesUrl + "&LoginUserId="+merchantdata.UserId);
  }
  // NewInvoice(data)
  // {
  //   alert(data);
  //   data.UserId=this.userId;
  //   return this.service.create(environment.newInvoiceUrl,data);
  // }
  GetInvoices(data) {
    this.GetHeaderdetails();
    // alert(merchantKeyId);
    return this.http
      .get<VposInvoiceAppView>(environment.invoicelistUrl + "?MerchantKeyId=" + data)
      .pipe(map(response => response) ,catchError(this.common.handleError));
  }
  ViewInvoice(data, MerchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http
      .get<VposInvoiceAppView>(
        environment.viewInvoiceUrl +
          "?id=" + data +"&MerchantKeyId=" +MerchantKeyId+"&LoginUserId="+merchantdata.UserId
          ,{headers:this.headers}
      )
      .pipe(map(response => response) ,catchError(this.common.handleError));
  }

  deleteInvoice(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.put(environment.deleteInvoiceUrl, data
    ,{headers:this.headers});
   
  }
  SendReminder(data) {
    this.GetHeaderdetails();
    return this.http.put(environment.SendReminder, data,{headers:this.headers});
  }
  // EditInvoice(data)
  // {
  //   data.UserId=this.userId;
  //   return this.http.get(environment.editInvoiceUrl+"?id="+data);
  // }
  getInvoice(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<VposInvoiceAppView>(
      environment.getInvoiceUrl +
        "?id=" +
        data.id +
        "&merchantKeyId=" +
        data.merchantKeyId
        + "&LoginUserId="+merchantdata.UserId
,{headers:this.headers}
    );
  }

  invoicelistUrl(MerchantKeyId, userid) {
    let loggedUsername =this.common.getUserName()
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token =environment.GetAuthenticationToken + ":" +this.common.GetAuthToken()+ ":" + "IT"+ ":"+environment.GetAuthencticationKey+":"+this.common.getSid()+":"+merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
    set('Authorization', 'basic ' + btoa(this.token));
    return this.http.get<any>(environment.invoicelistUrl +"?MerchantKeyId="+MerchantKeyId +"&UserId="+userid+ "&LoginUserId="+merchantdata.UserId,{headers:this.headers});
  }


  invoiceFilterdataurl(data) {
    
  this.GetHeaderdetails();
  const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.post<any>(environment.invoiceFilterdataurl,data ,{headers:this.headers});
  }


  
 GetHeaderdetails()
 {
   let loggedUsername =this.common.getUserName()
   const merchantdata: UserMerchantData = this.common.getUserMerchantData();
   this.token =environment.GetAuthenticationToken + ":" +this.common.GetAuthToken()+ ":" + "IT"+ ":"+environment.GetAuthencticationKey+":"+this.common.getSid()+":"+merchantdata.MerchantKeyId;
   this.headers = new HttpHeaders().
   set('Authorization', 'basic ' + btoa(this.token));


 }

          //     environment.invoiceFilterdataurl + "?MerchantKeyId=" + this.MerchantKeyId + "&fromdate=" + this.Fromdate1 + "&todate=" + this.todate1 + "&transactionStatus=" + transactionStatus
        //     + "&Email=" + Email + "&Amount=" + Amount + "&id=" + id + "&Cid=" + cid + "&AmountCheck=" + amountcompare+ "&UserId=" + this.loggedinuseremail);
}
